export default function(state={}, action){
    switch(action.type){
        case "GET_LOGIC_GRAPH_DATA":
            return action.payload;
        default:
            return state;
    }
}